export default "__VITE_ASSET__DoRLz1dx__"